// YunEmHumanize.js
import { memo } from 'react';

import './YunEmHumanize.css';
import YunIcon from '../YunIcon/YunIcon';

import Slider from '@material-ui/core/Slider';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputBox from '../InputBox/InputBox';

import { sliderConfig, formatShowValue } from '../YunEmFineTune/tool';

const YunEmHumanize = memo(function YunEmHumanize({ emHumanize, emHumanizeVal, handleEmHumanize, humanizePreset }) {

    const labelValue = formatShowValue(emHumanizeVal, humanizePreset)

    // 做反向处理 100%在最左侧 0%在最右侧
    // const showValue = sliderConfig.max - emHumanizeVal
    // const handleSlider = (e, val) => {
    //     handleEmHumanize(sliderConfig.max - val)
    // }

    if (!emHumanize) {
        return null
    }
    const MenuItemEle = []
    humanizePreset.forEach((ele, index) => {
        MenuItemEle.push(<MenuItem className="SelectItem" value={ele.value} key={'humanize-item-' + index}>{ele.name}</MenuItem>)
    })

    return (
        <div className="YunCommonLayoutWrapper">
            <div className="YunEmHumanize YunCommonLayout">
                <div className="Label CursorDefault">
                    拟人：
                </div>
                <Slider
                    value={emHumanizeVal}
                    onChange={(e, val) => handleEmHumanize(val)}
                    min={sliderConfig.min}
                    max={sliderConfig.max} />
                <div className="RateSelect">
                    <div className="RateSelectLabel HoverColor MainColor">{labelValue}</div>
                    <YunIcon iconClass="MainColor HoverColor" icon="expand"></YunIcon>
                    <Select value="" onChange={(e, child) => handleEmHumanize(child.props.value)}>
                        {MenuItemEle}
                        <InputBox val={emHumanizeVal} min={0} max={100} step={1} onChange={handleEmHumanize} >
                        </InputBox>
                    </Select>
                </div>
            </div>
        </div>
    )
})

export default YunEmHumanize;
